/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import { Breadcrumb, BreadcrumbItem, Container, Row, Col,Button } from "reactstrap";

function TimelineHeaderMobile({ name, to, judul }) {
  return (
    <>
      <div className="header header-dark bg-gradient-info pb-6 content__title content__title--calendar">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6" xs="7">
                  <Link color="white" to={to}>
                    <i className="fa fa-arrow-circle-left fa-2x" /> 
                  </Link>
                {/* <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0">
                  {judul}
                </h6>{" "} */}
                <Breadcrumb
                  className="d-none d-md-inline-block ml-lg-4"
                  listClassName="breadcrumb-links breadcrumb-dark"
                >
                  <BreadcrumbItem>
                    <a href="../../admin/dashboard" >
                      <i className="fas fa-home" />
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem aria-current="page" className="active">
                    {name}
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

TimelineHeaderMobile.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
};

export default TimelineHeaderMobile;